import { useIntl } from 'react-intl'
import { GuideView } from '../../Components/DevelopmentGuide/guideView'
import { developmentGuideTranslate } from '../../i18n/translatedMessages'

export function EmployeeDevelopmentGuide() {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const employee = JSON.parse(localStorage.getItem('user'))

	return (
		<div className='tw-mr-16'>
			<div className='tw-font-bold tw-text-2xl tw-mb-4'>{developmentGuideTranslate.developmentGuideTitle}</div>
			<div className='tw-mb-5'>{developmentGuideTranslate.developmentGuideDescEE}</div>
			<GuideView employee={employee} language={language} employeeView={true} />
		</div>
	)
}

